import React, { useEffect, useState } from 'react';
import config from '../../../config/config';
import ApiClient from '../../../redux/models/src/ApiClient';
import cookies from 'react-cookies';
import { useDispatch, useSelector } from 'react-redux';
import { getUserPageAuth } from '../../../utils/page-auth';
import { inAppIconsListRequest } from '../../../redux/actions/app/inAppIconsActions';
import { Helmet } from 'react-helmet';
import Visible from '../../../components/Custom/Visible';
import Notification from '../../../components/Notification/Notification';
import axios from 'axios';
import useTranslation from '../../../hooks/useTranslation';
import useSchemaIconUpload from '../../../schema/table-schema/useSchemaIconUpload';
import BOTable from '../../../components/Tables/BOTable';

function InAppIcons() {
  // -- component const --//
  // 페이지 제목
  const title = 'admin.app.icon.upload.title'; // '인앱 아이콘 관리';

  const { t } = useTranslation();
  const { schema } = useSchemaIconUpload();

  const allowedTypes = [
    'image/jpeg',
    'image/jpg',
    'image/png',
    'image/gif',
    'image/webp',
    'video/mp4',
    'video/webm',
    'video/mov',
  ];

  const apiURL = config?.API_URL;
  const apiClient = new ApiClient();
  const headerData = apiClient?.defaultHeaders;
  const accessToken = cookies?.load('token');

  // -- useSelector & dispatch --//
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.authReducer.user);

  // -- state --//
  const [readOnly, setReadOnly] = useState(true);

  const [notificationMessage, setNotificationMessage] = useState('');
  const [showNotification, setShowNotification] = useState(false);

  const [list, setList] = useState();
  const [totalCount, setTotalCount] = useState(0);

  const [image, setImage] = useState(null);
  const [previewUrl, setPreviewUrl] = useState('');
  const [fileName, setFileName] = useState('');

  // 로딩
  const [isLoading, setIsLoading] = useState(false);

  // 이미지 || 비디오 상태
  const [fileKind, setFileKind] = useState('');

  // -- func & handler --//
  const fetchList = () => {
    setIsLoading(true);

    dispatch(
      inAppIconsListRequest({
        callback: (data) => {
          console.log('요청 결과: ', data);
          setIsLoading(false);
          setList(
            data?.list.map((e, idx) => {
              // return { index: idx + 1, path: e?.split('?').at(0) ?? '' };
              return { index: idx + 1, path: e };
            }),
          );
          setTotalCount(data?.list?.length);
        },
        error: (e) => {
          console.log(e);
          setIsLoading(false);
          setNotificationMessage(e.toString());
          setShowNotification(true);
        },
      }),
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!image) {
      setNotificationMessage('이미지를 업로드 해주세요.');
      setShowNotification(true);
      return;
    }

    try {
      const formData = new FormData();
      formData?.append('File', image);
      formData?.append('FileName', fileName);

      for (const key of formData?.keys()) {
        console.log(key, ':', formData?.get(key));
      }

      const response = await axios.post(
        `${apiURL}api/System/ItemIconUpload`,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
            AccessToken: accessToken,
            'CF-Access-Client-Id': headerData['CF-Access-Client-Id'],
            'CF-Access-Client-Secret': headerData['CF-Access-Client-Secret'],
          },
        },
      );

      console.log('요청 결과:', response);
      setNotificationMessage('이미지 등록이 완료되었습니다.');
      setShowNotification(true);

      // 등록 조건 초기화
      setFileName('');
      setImage(null);
      document.getElementById('file-input').value = null; // input 창의 파일 명 미리보기까지 초기화
      setPreviewUrl('');

      setTimeout(() => {
        // 페이지 초기화
        window.location.reload();
      }, [1500]);
    } catch (error) {
      console.error('Error:', error);
      setNotificationMessage(error.toString());
      setShowNotification(true);
    }
  };

  // -- react hooks --//
  useEffect(() => {
    getUserPageAuth(user).then((res) => setReadOnly(res));
  }, [user]);

  useEffect(() => {
    fetchList();
  }, []);

  return (
    <div className="page">
      <Helmet>
        <title>{t(title)}</title>
      </Helmet>

      <div className="topSection">
        <div className="leftSection">
          <p className="titleText">{t(title)}</p>
        </div>
      </div>

      <div className="spaceDiv10"/>

      <div className="contentsArea paddingAll">
        <div className="rowDiv">
          <div className="descDiv date">
            <input
              id="file-input"
              type="file"
              onChange={(e) => {
                const file = e.target.files[0];

                if (allowedTypes?.includes(file?.type) === false) {
                  setImage(null);
                  document.getElementById('file-input').value = null;
                  setPreviewUrl('');
                  setNotificationMessage('파일 확장자를 확인해주세요.');
                  setShowNotification(true);
                  return;
                }

                file?.type.includes('video')
                  ? setFileKind('video')
                  : setFileKind('image');

                if (file && file.size <= 1024 * 1024 * 30) {
                  // 파일 용량이 30MB 이하인 경우에만 업로드
                  setImage(file);
                  const reader = new FileReader();

                  console.log('file: ', file);
                  console.log('reader: ', reader);

                  reader.onloadend = () => {
                    setPreviewUrl(`${reader.result}`);
                  };
                  reader.readAsDataURL(file);

                  // 업로드 한 파일명 그대로 적용
                  setFileName(file.name);

                  return reader;
                } else {
                  // 파일 용량 초과 시에는 경고 메시지 등을 표시할 수 있습니다.
                  setNotificationMessage('파일 크기는 30MB 이하여야 합니다.');
                  setShowNotification(true);
                }
              }}
              disabled={readOnly}
            />

            <input value={fileName} placeholder="선택된 파일 이름 사용" disabled={true}/>

            <button
              className="defaultBtn fit error"
              onClick={() => {
                setFileName('');
                setImage(null);
                document.getElementById('file-input').value = null; // input 창의 파일 명 미리보기까지 초기화
                setPreviewUrl('');
              }}
              disabled={readOnly}
            >
              취소
            </button>

            <button
              className="defaultBtn"
              onClick={handleSubmit}
              disabled={readOnly}
            >
              아이콘 파일 등록
            </button>
          </div>
        </div>

        <div className="spaceDiv10"/>

        <div
          className="rowDiv flex space-between"
          style={{ alignItems: 'center' }}
        >
          <Visible visible={previewUrl.length > 0}>
            <Visible visible={fileKind === 'image'}>
              <img
                alt="업로드 할 이미지"
                src={previewUrl}
                style={{
                  width: 200,
                }}
              />
            </Visible>

            <Visible visible={fileKind === 'video'}>
              <video
                src={previewUrl}
                autoPlay
                loop
                style={{
                  width: 200,
                }}
              />
            </Visible>
          </Visible>
        </div>
      </div>

      <div className="spaceDiv10"/>

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <p
          style={{ cursor: 'pointer', color: '#7B66FF' }}
          onClick={() => {
            fetchList();
          }}
        >
          List 갱신
        </p>

        <p style={{ textAlign: 'right' }}>
          전체 {totalCount?.toLocaleString()} 항목
        </p>
      </div>

      <div className="spaceDiv10"/>

      <BOTable
        className={'inapp-icon-table'}
        schema={schema}
        rows={list}
        loading={isLoading}
        onClick={null}
      />

      {showNotification ? (
        <Notification
          close={() => setShowNotification(false)}
          message={notificationMessage}
        />
      ) : null}
    </div>
  );
}

export default InAppIcons;
